"use strict";
// Category utility helpers for Fomo-Fi web and mobile.
Object.defineProperty(exports, "__esModule", { value: true });
exports.filterCategoriesByType = filterCategoriesByType;
exports.findCategoryById = findCategoryById;
exports.buildCategoryMap = buildCategoryMap;
exports.getRootCategories = getRootCategories;
exports.getSubcategories = getSubcategories;
exports.getDefaultCategoryColor = getDefaultCategoryColor;
exports.foldCategoryName = foldCategoryName;
exports.preferOwnCategories = preferOwnCategories;
/**
 * Filter categories by type.
 */
function filterCategoriesByType(categories, type) {
    return categories.filter((c) => c.type === type);
}
/**
 * Find a category by ID.
 */
function findCategoryById(categories, id) {
    return categories.find((c) => c.id === id);
}
/**
 * Build a map of category ID → Category for O(1) lookups.
 */
function buildCategoryMap(categories) {
    return new Map(categories.map((c) => [c.id, c]));
}
/**
 * Get top-level categories (no parent).
 */
function getRootCategories(categories) {
    return categories.filter((c) => c.parentId === null);
}
/**
 * Get subcategories of a given parent.
 */
function getSubcategories(categories, parentId) {
    return categories.filter((c) => c.parentId === parentId);
}
/**
 * Get default category color based on category type.
 */
function getDefaultCategoryColor(type) {
    const defaults = {
        income: "#22c55e",
        expense: "#ef4444",
        transfer: "#3b82f6",
    };
    return defaults[type];
}
/** A category name as a person reads it: case and spacing ignored (FP-100's
 *  `fold_category_name` on the server). */
function foldCategoryName(name) {
    return name.split(/\s+/).filter(Boolean).join(" ").toLowerCase();
}
/**
 * Picker lists: when the user's own category has the same name as a built-in one, list
 * only the user's. Ids in `keep` (a row's current category, a category that already has
 * a budget) are never dropped.
 *
 * The workbook accounts hold user-owned copies of 12 built-in names (the importer
 * creates its 44 categories user-scoped), so every picker listed "Dining Out" twice and
 * the first was the built-in one: a hand-entered Dining Out purchase missed the budget
 * the user had set on their own copy (found verifying #1977, 2026-10-15). Ordinary
 * sign-ups cannot make such a pair: FP-100's name check refuses it. Lookups by id must
 * keep using the full list.
 *
 * Rows come camelised (shared's `Category`, mobile: `isSystem`) or as the API sends them
 * (web: `is_system`); both are read, or pass `isSystem` to say how (rule 17 with mobile).
 */
function preferOwnCategories(categories, options = {}) {
    const keep = options.keep ?? [];
    const isSystem = options.isSystem ??
        ((c) => {
            const row = c;
            return Boolean(row.isSystem ?? row.is_system);
        });
    const own = new Set(categories.filter((c) => !isSystem(c)).map((c) => foldCategoryName(c.name)));
    return categories.filter((c) => !isSystem(c) || keep.includes(c.id) || !own.has(foldCategoryName(c.name)));
}
//# sourceMappingURL=category.js.map